import React from "react";
import { ChevronLeft } from "lucide-react";
import { Button } from "../ui/button";

interface ChatHeaderProps {
  onToggleCollapse: () => void;
}

/**
 * Header bar for the expanded chat panel: title and a collapse affordance.
 */
export function ChatHeader({ onToggleCollapse }: ChatHeaderProps) {
  return (
    <div className="px-4 py-3 bg-background">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-bold text-foreground pt-2">Assistant</h3>
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleCollapse}
          className="h-8 w-8 text-muted-foreground hover:text-foreground"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

export default ChatHeader;
